<template>
  <div class="fin-panel-body">
    <ui-banner v-if="note" tone="info">{{ translate(note) }}</ui-banner>

    <dl class="fin-kv">
      <dt>{{ $t("finance_shell.pending.count") }}</dt><dd class="fin-num">{{ count }}</dd>
      <dt>{{ $t("finance_shell.pending.sum") }}</dt><dd class="fin-num">{{ money(valueSum) }}</dd>
    </dl>

    <div class="fin-pend">
      <div v-for="row in rows" :key="row.key" class="fin-pend__row">
        <span class="fin-pend__head">
          <b class="fin-num">#{{ row.orderId }}</b>
          <span v-if="row.outcome" class="ui-chip" :class="row.outcome === 'failed' ? 'ui-chip--warn' : ''">{{ outcomeText(row.outcome) }}</span>
        </span>
        <b class="fin-num">{{ row.value === null ? "—" : money(row.value) }}</b>
        <small>
          {{ localeDate(row.date) }}<template v-if="paymentText(row.paymentMethod)"> · {{ paymentText(row.paymentMethod) }}</template>
        </small>
        <small v-if="row.finalAt" class="fin-pend__since">{{ $t("finance_shell.pending.since", { date: localeDate(row.finalAt) }) }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import { formatMoney } from "@/components/restaurant/finance/constants";

/** Narudžbe koje čekaju knjiženje (lista iz trake): broj narudžbe, ishod, način plaćanja, vrijednost i od kada čekaju. Samo pregled. */
export default {
  name: "FinancePendingPanel",
  props: {
    rows: { type: Array, required: true },
    count: { type: Number, default: 0 },
    valueSum: { type: Number, default: 0 },
    note: { type: String, default: "" },
    currency: { type: String, default: "KM" },
  },
  methods: {
    money(value) {
      return formatMoney(value, this.currency);
    },
    outcomeText(outcome) {
      const key = `finance_shell.pending.outcome.${outcome}`;
      return this.$te(key) ? this.$t(key) : this.toLatin(outcome);
    },
    paymentText(method) {
      return method === "CARD" ? this.$t("finance_payment_card") : method === "CASH" ? this.$t("finance_payment_cash") : "";
    },
  },
};
</script>
